module.exports = __webpack_public_path__ + "img/intropage-st-only-connectors.518fff70.svg";